import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LearnitDataItemsApi from '../generated/api/LearnitDataItems';

export default (service: Servicelayer) => ({
  ...LearnitDataItemsApi(service),

  // Add custom calls here

});
